import React, { Component } from "react";
import { Div, Image, Button, Text, Collapse } from "atomize";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import { Transition } from "react-transition-group";
import Div100vh from "react-div-100vh";
import MobileMenuCollapseItems from "../common/MobileMenuCollapseItems";
import AnimateLink from "./AnimateLink";

const duration = 300;

const defaultStyle = {
  transition: `max-height ${duration}ms ease-in-out`,
  maxHeight: 0,
  height: "100%",
};

const transitionStyles = {
  entering: { maxHeight: "100vh" },
  entered: { maxHeight: "100vh" },
  exiting: { maxHeight: "0" },
  exited: { maxHeight: "0" },
};

export default class MobileHeaderMenu extends Component {
  constructor(props) {
    super(props);

    this.targetElement = React.createRef();
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  onEntering = () => {
    // console.log(this.targetElement.current.clientHeight);
    document.documentElement.classList.add("stop-home-slider");
    disableBodyScroll(this.targetElement.current);
  };

  onExiting = () => {
    document.documentElement.classList.remove("stop-home-slider");
    enableBodyScroll(this.targetElement.current);
  };

  render() {
    const {
      mobileHeaderOpen,
      toggleCollapse,
      showCollapse,
      headerLinks,
      toggleMobileHeader,
      getStartedContent,
    } = this.props;

    return (
      <Transition
        onEntering={this.onEntering}
        onExiting={this.onExiting}
        in={mobileHeaderOpen}
        timeout={duration}
      >
        {state => (
          <Div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            pos="fixed"
            top="0"
            left="0"
            right="0"
            d={{ lg: "none" }}
            bg="black"
            zIndex="-1"
            overflow="hidden"
          >
            <Div100vh>
              <Div
                maxH="100%"
                fontFamily="secondary"
                pos="absolute"
                top="0"
                left="0"
                right="0"
                h="100%"
                d="flex"
                flexDir="column"
                justify="space-between"
                pos="relative"
              >
                <Div ref={this.targetElement} overflow="auto" flexGrow="1">
                  <Div
                    p={{ xs: "6rem 1.5rem 4rem", sm: "9rem 2.5rem 6rem" }}
                    d="flex"
                    flexDir="column"
                  >
                    {headerLinks.map((link, index) => {
                      const isSelected = showCollapse === index;

                      if (link.submenu) {
                        return (
                          <Div order={link.submenu && "2"}>
                            <Div
                              d="flex"
                              onClick={() => {
                                toggleCollapse(index);
                                !link.submenu && toggleMobileHeader(false);
                              }}
                              align="center"
                              m={{ b: "2rem" }}
                              textColor="#6B6B6B"
                              hoverTextColor="white"
                            >
                              <Text
                                textSize="caption3"
                                textWeight="600"
                                cursor="pointer"
                                transition="default"
                                className="link-name"
                              >
                                {link.name}
                              </Text>
                              {link.submenu && (
                                <Image
                                  transform={isSelected && "rotate(180deg)"}
                                  m="2px 0 0 0.75rem"
                                  src="/images/downarrow.png"
                                  h="5px"
                                  w="auto"
                                ></Image>
                              )}
                            </Div>

                            <Collapse isOpen={isSelected}>
                              {link.submenu && (
                                <MobileMenuCollapseItems
                                  toggleMobileHeader={toggleMobileHeader}
                                  submenu={link.submenu}
                                />
                              )}
                            </Collapse>
                          </Div>
                        );
                      }

                      return (
                        <AnimateLink
                          to={link.link}
                          activeClassName="active"
                          className="gatsby-link"
                        >
                          <Div
                            d="flex"
                            onClick={() => {
                              !link.submenu && toggleMobileHeader(false);
                            }}
                            align="center"
                            m={{ b: "2rem" }}
                            textColor="#6B6B6B"
                            hoverTextColor="white"
                          >
                            <Text
                              textSize="caption3"
                              textWeight="600"
                              cursor="pointer"
                              transition="default"
                              className="link-name"
                            >
                              {link.name}
                            </Text>
                            {link.submenu && (
                              <Image
                                transform={isSelected && "rotate(180deg)"}
                                m="2px 0 0 0.75rem"
                                src="/images/downarrow.png"
                                h="5px"
                                w="auto"
                              ></Image>
                            )}
                          </Div>
                        </AnimateLink>
                      );
                    })}
                  </Div>
                </Div>
                <Div
                  pos="absolute"
                  bottom="0"
                  left="0"
                  right="0"
                  w="100%"
                  bg="#212121"
                  p="0.8rem 0.63rem 0.63rem"
                  className="mobile-menu-footer"
                  border={{ t: "1px solid" }}
                  borderColor="primary"
                >
                  <Div
                    className="footer-label-arrow"
                    w="0"
                    h="0"
                    pos="absolute"
                    top="0"
                    left="50%"
                    transform="translateX(-50%) rotate(180deg)"
                  />
                  <Div
                    className="footer-label"
                    textAlign="center"
                    m={{ b: "0.82rem" }}
                  >
                    <Text
                      textSize="caption1"
                      textColor="white"
                      textTransform="uppercase"
                      textWeight="700"
                    >
                      {getStartedContent.getStarted.label}
                    </Text>
                  </Div>
                  <Div d="flex" w="100%">
                    {getStartedContent.getStarted.links.map(item => (
                      <Div flexGrow="1" m={{ r: "0.63rem" }}>
                        <AnimateLink to={item.link}>
                          <Button
                            onClick={() => toggleMobileHeader(false)}
                            textSize="paragraph"
                            fontFamily="secondary"
                            h="3.125rem"
                            bg="primary"
                            hoverBg="warning900"
                            rounded="0"
                            p={{ x: { xs: "0.75rem", sm: "1rem" } }}
                            textWeight="700"
                            textColor="black"
                            w="100%"
                            rounded="sm"
                          >
                            {item.text}
                          </Button>
                        </AnimateLink>
                      </Div>
                    ))}
                    {/* <Div flexGrow="1">
                      <AnimateLink to="schedule-a-demo">
                        <Button
                          onClick={() => toggleMobileHeader(false)}
                          textSize="paragraph"
                          fontFamily="secondary"
                          h="3.125rem"
                          bg="primary"
                          hoverBg="warning900"
                          rounded="0"
                          p={{ x: { xs: "0.75rem", sm: "1rem" } }}
                          textWeight="700"
                          textColor="black"
                          w="100%"
                          rounded="sm"
                        >
                          Brands
                        </Button>
                      </AnimateLink>
                    </Div> */}
                  </Div>
                </Div>
              </Div>
            </Div100vh>
          </Div>
        )}
      </Transition>
    );
  }
}
